import clsx from "clsx";
import { DetailedHTMLProps, HTMLAttributes } from "react";

interface ContainerProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  tag?:
    | "article"
    | "aside"
    | "div"
    | "footer"
    | "header"
    | "main"
    | "nav"
    | "section";
  width?: "2xl" | "lg" | "xl";
}

export const containerPadding = "px-4 md:px-6 lg:px-8 print:px-0";

function Container({
  children,
  className,
  tag: Tag = "div",
  width = "2xl",
  ...props
}: ContainerProps) {
  const widthClass: Record<Required<ContainerProps>["width"], string> = {
    "2xl": "max-w-screen-2xl",
    lg: "max-w-screen-lg",
    xl: "max-w-screen-xl",
  };

  return (
    <Tag
      className={clsx(
        "container mx-auto w-full",
        containerPadding,
        widthClass[width],
        className
      )}
      {...props}
    >
      {children}
    </Tag>
  );
}

export default Container;
